import { applyPatch, Operation } from 'fast-json-patch';

export function applyStateDelta<T extends object>(state: T, delta: readonly Operation[]): T {
  const { newDocument } = applyPatch(structuredClone(state), delta as Operation[], true, false);
  return newDocument as T;
}
